import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";
import helperTime from "../../../../helpers/time";
import httpService from "../../../../services/httpServices/httpServices";
import StatusAskTransaction from "./../StatusAskTransaction";

export default function InfoAskTransaction() {
  const [askTransaction, setAskTransaction] = useState();
  const [receiptPaymentImage, setReceiptPaymentImage] = useState();
  const [state, newState] = useState(
    StatusAskTransaction.statusAskTransaction.PAID
  );
  const params = useParams();
  const askTransactionID = params.askTransactionID;
  const history = useHistory();
  useEffect(() => {
    getAskTransaction();
  }, []);

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getAskTransaction = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let askTransaction = await sendRequestGetAskTransaction(askTransactionID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!askTransaction) {
      return;
    }

    setAskTransaction(askTransaction);
  };

  const sendRequestGetAskTransaction = async (askTransactionID) => {
    const headersRequest = getHeaderRequest();
    let askTransaction;
    try {
      askTransaction = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/publisher/finance/ask-transaction/" +
          askTransactionID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return askTransaction.data.data;
  };

  const sendForm = async () => {
    const formData = getFormData();

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let resultEditAskTransaction = await sendRequestSetNewStateAskTransaction(
      askTransactionID,
      formData
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultEditAskTransaction) {
      return;
    }

    history.push("/finance/manage/ask-transaction/all");
  };

  const getFormData = () => {
    const formData = new FormData();
    formData.append("state", state);
    if (state == StatusAskTransaction.statusAskTransaction.PAID) {
      formData.append("image", receiptPaymentImage);
    } else if (state == StatusAskTransaction.statusAskTransaction.REJECT) {
      formData.append(
        "message",
        document.querySelector("#reason-reject").value
      );
    }
    return formData;
  };

  const sendRequestSetNewStateAskTransaction = async (
    askTransactionID,
    formData
  ) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/publisher/finance/ask-transaction/" +
          askTransactionID,
        formData,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const generateAskTransaction = () => {
    let classBadgeStatePage;
    switch (askTransaction.pat_status) {
      case StatusAskTransaction.statusAskTransaction.PENDING:
        classBadgeStatePage = "badge-warning";
        break;
      case StatusAskTransaction.statusAskTransaction.PAID:
        classBadgeStatePage = "badge-info";
        break;
      case StatusAskTransaction.statusAskTransaction.REJECT:
        classBadgeStatePage = "badge-danger";
        break;
    }

    return (
      <div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  اطلاعات وارد شده برای درخواست انتقال وجه
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>شماره درخواست</td>
                <td> {helperNumbers.toPersianNum(askTransaction.pat_id)}</td>
              </tr>
              <tr>
                <td>مبلغ (تومان)</td>
                <td>
                  <label className="letter-spacing-finance-number pl-2">
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(
                        askTransaction.pat_price
                      )
                    )}
                  </label>
                  <label>تومان</label>
                </td>
              </tr>
              <tr>
                <td>نام بانک </td>
                <td>{askTransaction.pat_bank_name}</td>
              </tr>
              <tr>
                <td>نام مالک حساب</td>
                <td>{askTransaction.pat_owner_account_name}</td>
              </tr>
              <tr>
                <td>شماره حساب بانکی</td>
                <td>{askTransaction.pat_account_number}</td>
              </tr>
              <tr>
                <td>شماره کارت بانکی </td>
                <td>{askTransaction.pat_account_cart_number}</td>
              </tr>
              <tr>
                <td>شماره شبا </td>
                <td>{askTransaction.pat_account_shaba_number}</td>
              </tr>
              <tr>
                <td>وضعیت</td>
                <td>
                  <span className={`badge ${classBadgeStatePage}`}>
                    {
                      StatusAskTransaction.getStatusAskTransactionString()[
                        askTransaction.pat_status
                      ]
                    }
                  </span>
                </td>
              </tr>

              {StatusAskTransaction.statusAskTransaction.REJECT ==
                askTransaction.pat_status && (
                <tr>
                  <td>دلیل رد شدن</td>
                  <td> {askTransaction.pat_message}</td>
                </tr>
              )}
              {StatusAskTransaction.statusAskTransaction.PAID ==
                askTransaction.pat_status && (
                <>
                  <tr>
                    <td>عکس رسید پرداخت</td>
                    <td>
                      <a
                        target="_blank"
                        href={askTransaction.pat_receipt_payment_image}
                      >
                        <img
                          className="img-fluid"
                          src={askTransaction.pat_receipt_payment_image}
                        />
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>تاریخ پرداخت</td>
                    <td>
                      {helperNumbers.toPersianNum(
                        askTransaction.pat_paid_at.split(" ")[1] +
                          " " +
                          helperTime.convertGregorianToJalali(
                            askTransaction.pat_paid_at.split(" ")[0]
                          )
                      )}
                    </td>
                  </tr>
                </>
              )}

              <tr>
                <td>تاریخ درج</td>
                <td>
                  {helperNumbers.toPersianNum(
                    askTransaction.pat_created_at.split(" ")[1] +
                      " " +
                      helperTime.convertGregorianToJalali(
                        askTransaction.pat_created_at.split(" ")[0]
                      )
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr />
        <h3>اعمال وضعیت جدید درخواست انتقال وجه کاربر نمایش دهنده</h3>
        <div className="alert alert-warning">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <p className="text-justify">
            درصورت موافقت و پرداخت مبلغ به حساب بانکی کاربر نمایش دهنده حتما
            طریق
            <Link
              className="d-inline-block px-2"
              target="_blank"
              to="/finance/manage/transaction-manually/add"
            >
              تراکنش دستی
            </Link>
            موجود کاربر را به اندازه مبلغ پرداخت شده کسر کنید
          </p>
        </div>
        <div className="pt-2">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              sendForm();
            }}
          >
            <div className="form-group w-50">
              <label>وضعیت جدید</label>
              <select
                className="form-control"
                onChange={(e) => {
                  newState(e.target.value);
                }}
              >
                <option value={StatusAskTransaction.statusAskTransaction.PAID}>
                  {
                    StatusAskTransaction.getStatusAskTransactionString()[
                      StatusAskTransaction.statusAskTransaction.PAID
                    ]
                  }
                </option>
                <option
                  value={StatusAskTransaction.statusAskTransaction.REJECT}
                >
                  {
                    StatusAskTransaction.getStatusAskTransactionString()[
                      StatusAskTransaction.statusAskTransaction.REJECT
                    ]
                  }
                </option>
              </select>
            </div>
            {state == StatusAskTransaction.statusAskTransaction.PAID && (
              <div className="form-group">
                <label>عکس رسید پرداخت</label>
                <input
                  required
                  className="form-control"
                  id="receipt-payment-image"
                  type="file"
                  accept="image/png, image/gif, image/jpeg, image/webp"
                  onChange={(e) => {
                    setReceiptPaymentImage(e.target.files[0]);
                  }}
                />
              </div>
            )}
            {state == StatusAskTransaction.statusAskTransaction.REJECT && (
              <div className="form-group">
                <label>دلیل رد شدن</label>
                <textarea
                  className="form-control"
                  id="reason-reject"
                  rows="10"
                  required
                ></textarea>
              </div>
            )}
            <div>
              <button className="btn btn-success">اعمال وضعیت جدید</button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="مشاهده وضعیت درخواست انتقال موجودی" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to="/finance/manage/ask-transaction/all"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div>{askTransaction && generateAskTransaction()}</div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
